import { Link } from 'react-router-dom';
import { SignInBrandLogo, useBranding } from '@l2u/web-shared';
import { supportEmailOf } from '@l2u/shared/brandingDefaults';
import { driverPath } from '../lib/audienceRoutes.ts';

/**
 * The driver's own lapsed-session page.
 *
 * A driver whose session expired used to be sent to /c/expired — copy written
 * for their employer, telling them to "contact your administrator to receive a
 * new invitation": an administrator they have never met, in a message addressed
 * to somebody else, with no way to act. There was no /d/expired route at all.
 *
 * The driver has a self-service route now, so this page's job is to point at it
 * rather than at a person.
 */
export function DriverExpired() {
  const { branding } = useBranding();
  const supportEmail = supportEmailOf(branding);
  return (
    // `driver-portal` opts this page into the phone touch-target rules in
    // index.css — see DriverShell.
    <div className="driver-portal flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <SignInBrandLogo align="center" className="mb-3" />
        <p className="mt-2 text-sm text-slate-600">
          Your sign-in link has expired. Links are single-use, so you’ll need a fresh one.
        </p>
        <div className="mt-5">
          <Link
            to={driverPath('/login')}
            // An <a>, so the driver-portal button rule in index.css does not
            // reach it; this is the only action on the page.
            className="inline-flex min-h-[44px] items-center rounded-lg px-4 py-2 text-sm font-semibold text-white"
            style={{ background: 'var(--brand-primary)' }}
          >
            Email me a new sign-in link
          </Link>
        </div>
        <p className="mt-5 text-sm text-slate-500">
          Need help? Email{' '}
          <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
            {supportEmail}
          </a>
          .
        </p>
      </div>
    </div>
  );
}
